import type { PropsWithChildren } from 'react'

import { type TextOptions, isHeadingSize } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { TestIds } from '../../utils'
import { Heading } from '../heading/heading.tsx'
import { Text } from '../text'

export type BladeTitleProps = Readonly<
  PropsWithChildren<
    TextOptions & {
      truncate?: boolean
    } & TestIds
  >
>

export const BladeTitle = ({
  children,
  fontSize = 'lg',
  textColor = 'primary',
  fontWeight = 'bold',
  truncate,
  ...rest
}: BladeTitleProps) => {
  const props = {
    className: cn(truncate ? 'truncate' : 'line-clamp-1 flex grow'),
    textColor,
    fontWeight,
    ...rest,
  }

  if (isHeadingSize(fontSize)) {
    return (
      <Heading {...props} fontSize={fontSize}>
        {children}
      </Heading>
    )
  }

  return (
    <Text {...props} fontSize={fontSize}>
      {children}
    </Text>
  )
}
